module.exports = "<p>\r\n  applicationsrejected works!\r\n</p>\r\n"